export default class rmCopy {
    constructor() {
        return {
            restrict: 'A',
            controller: CopyController
        }
    }
};

class CopyController {
    constructor($scope, $element, Events, $filter) {
        let clipboard = new Clipboard($element[0]);

        clipboard.on('success', (e) => {
            $scope.$emit('clipboardCopy:success');
            Events.flashEvent('notification', $filter('translate')('GLOBAL:COPY_SUCCESS'));
            e.clearSelection();
        });

        clipboard.on('error', (e) => {
            Events.flashEvent('notification', 'Press Ctrl/Cmd+C to copy snippet.')
        });
    }
}
